(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class ThemeSlideshow {
      constructor(section) {
        this.section = section;
        this.viewport = section.querySelector('[data-slideshow-viewport]');
        this.slides = Array.from(section.querySelectorAll('[data-slideshow-slide]'));
        this.dots = Array.from(section.querySelectorAll('[data-slideshow-dot]'));
        this.previous = section.querySelector('[data-slideshow-prev]');
        this.next = section.querySelector('[data-slideshow-next]');
        this.interval = section.dataset.autoplay === 'true' ? Number(section.dataset.autoplaySpeed || 0) : 0;
        this.index = 0;
        this.timer = null;

        if (!this.viewport || this.slides.length < 2) return;

        this.previous?.addEventListener('click', () => this.goTo(this.index - 1));
        this.next?.addEventListener('click', () => this.goTo(this.index + 1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slideshowDot)));
        });
        this.viewport.addEventListener('scroll', () => this.syncFromScroll(), { passive: true });
        this.section.addEventListener('mouseenter', () => this.stop());
        this.section.addEventListener('mouseleave', () => this.start());
        this.start();
      }

      goTo(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.viewport.scrollTo({ left: this.viewport.clientWidth * this.index, behavior: 'smooth' });
        this.updateDots();
      }

      syncFromScroll() {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => {
          this.index = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
          this.updateDots();
        }, 80);
      }

      updateDots() {
        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === this.index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      start() {
        if (!this.interval) return;
        this.stop();
        this.timer = window.setInterval(() => this.goTo(this.index + 1), this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
      }
    }

    const initSlideshows = (root = document) => {
      root.querySelectorAll('[data-slideshow]').forEach((section) => {
        if (section.dataset.slideshowInitialized) return;
        section.dataset.slideshowInitialized = 'true';
        new ThemeSlideshow(section);
      });
    };

    initSlideshows();

    if (!window.themeSlideshowSectionLoad) {
      window.themeSlideshowSectionLoad = true;
      document.addEventListener('shopify:section:load', (event) => initSlideshows(event.target));
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
